const Check = () => (
  <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

// Horizontal category stepper across the top of the scorecard. `steps` is the
// ordered list of section labels (one per dimension) plus a trailing "Done".
// `current` is the index of the active step.
export default function SectionStepper({ steps, current }) {
  return (
    <ol className="stepper">
      {steps.map((label, i) => {
        const state = i < current ? 'done' : i === current ? 'current' : 'upcoming';
        return (
          <li key={i} className={`stepper-step ${state}`}>
            <span className="stepper-dot">{state === 'done' ? <Check /> : i + 1}</span>
            <span className="stepper-label">{label}</span>
          </li>
        );
      })}
    </ol>
  );
}
